import { RequestHeaders } from './utilities';
export function UserCommands(api) {
  return {
    profile: function profile() {
      return api.authenticated().get("User/GetProfile", {}, RequestHeaders);
    }
  };
}